import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { GrupoQuestaoModel, QuestionarioFiltroModel } from '../models';


@Injectable({
  providedIn: 'root'
})
export class QuestionarioFiltroService extends BaseCrudService<QuestionarioFiltroModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'questionarioFiltro';
  }

  getByQuestionarioId(id: string): Observable<QuestionarioFiltroModel[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetByQuestionarioId/${id}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }  

  updateOrdens(ids) {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/UpdateOrdens`, ids, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
